import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import GallerySection from "./components/GallerySection";
import ActivitiesSection from "./components/ActivitiesSection";
import BookingCTA from "./components/BookingCTA";
import Footer from "./components/Footer";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import AuthCallback from "./components/AuthCallback";
import Dashboard from "./components/Dashboard";
import BookingCalendar from "./components/BookingCalendar";
import GalleryPage from "./components/GalleryPage";
import ThingsToDoPage from "./components/ThingsToDoPage";
import AdminDashboard from "./components/AdminDashboard";

const Home = () => {
  return (
    <div className="min-h-screen bg-stone-900">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <GallerySection />
        <ActivitiesSection />
        <BookingCTA />
      </main>
      <Footer />
    </div>
  );
};

// App Router with auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (Google OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/book" element={<BookingCalendar />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/things-to-do" element={<ThingsToDoPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
